export enum ContactsTableAccessor {
  ContactNo = 'contactNo',
  Name = 'name',
  Type = 'type',
  ContactPersonEmail = 'contactPersonEmail',
  Phone = 'phone',
  Country = 'country',
  CreatedTime = 'createdTime',
}
